<div class="chat-wrapper" #contentDiv>

  <!-- =========================================================
       USER MESSAGE
  ========================================================== -->
  @if (data?.question) {

  <div class="chat-row user">

    <div class="chat-card user-card">

      @if (editingIndex !== index) {

      <div class="question-wrapper">

        <div class="question-text">
          {{ data.question }}
        </div>

        <div class="question-actions">

          <button type="button" class="icon-btn" (click)="copyQuestion(data.question)" pTooltip="Copy question"
            tooltipPosition="bottom">
            <i class="pi pi-copy"></i>
          </button>

        </div>

      </div>

      } @else {

      <div class="edit-wrapper">

        <textarea [(ngModel)]="editedQuestion" rows="2" class="edit-input"></textarea>

        <div class="edit-actions">

          <button type="button" class="cancel-btn" (click)="cancelEdit()">
            <i class="pi pi-undo"></i>
          </button>

          <button type="button" class="submit-btn" (click)="submitEditedQuestion(index)">
            <i class="pi pi-send"></i>
          </button>

        </div>

      </div>

      }

    </div>

  </div>

  }


  <!-- =========================================================
       BOT MESSAGE
  ========================================================== -->
  <div class="chat-row bot">

    <!-- AI Avatar -->
    <div class="avatar">
      <img [src]="getBotImage()" alt="AI" />
    </div>


    <!-- Chat Content -->
    <div class="chat-block">

      <div class="chat-card bot-card">


        <!-- =====================================================
             LOADING
        ====================================================== -->
        @if (aiLoading && !data?.answer) {

        <div class="ai-loader-container">

          <div class="ai-loader" aria-label="Loading">
            <span class="ai-loader-ring"></span>
            <span class="ai-loader-core"></span>
          </div>

          <div class="thinking-text">
            AI is preparing a helpful response...
          </div>

        </div>

        }


        <!-- =====================================================
             ANSWER
        ====================================================== -->

        @if (data?.answer) {

        <div class="answer" [class.typing]="isTyping" [innerHTML]="formatAnswer(data.answer)">
        </div>

        }


        <!-- =====================================================
             TYPING INDICATOR
        ====================================================== -->

        @if (isTyping && !data?.answer) {

        <div class="typing-indicator">

          <span></span>
          <span></span>
          <span></span>

        </div>

        }


        <!-- =====================================================
             COMPLETED RESPONSE
        ====================================================== -->

        @if (!isTyping && !aiLoading) {


        <!-- ===================================================
               SUGGESTED QUESTIONS
          ==================================================== -->

        @if (data?.suggestions?.length > 0) {
        <div class="ai-suggestions">

          <div class="suggestions-label">
            <i class="fa fa-lightbulb"></i>
            <span>Suggested questions</span>
          </div>

          <div class="suggestions-list">
            @for (suggestion of data.suggestions; track $index) {
            <button type="button" class="suggestion-btn" (click)="onSuggestionClick(suggestion)">
              <span class="suggestion-text">
                {{ suggestion }}
              </span>

              <i class="fa fa-arrow-right"></i>
            </button>
            }
          </div>

        </div>
        }

        <!-- ===================================================
               SOURCE DOCUMENT
          ==================================================== -->

        @if (data?.source_doc) {

        <div class="source-label py-1">

          <h5>
            Source of File:
          </h5>

          <p>
            {{ data.source_doc }}
          </p>

        </div>

        }


        <!-- ===================================================
               SOURCE PARAGRAPHS
          ==================================================== -->

        @if (data?.source_paragraphs?.length) {

        <div class="source-wrapper">

          <div class="source-card">

            <!-- Source Header -->
            <div class="source-header">

              <div class="source-title">

                <i class="fas fa-file-alt"></i>

                <span>
                  Source Information
                </span>

              </div>


              <button type="button" class="toggle-btn" (click)="toggleTextView()">

                <i class="fas" [ngClass]="
                        showTextView
                          ? 'fa-chevron-up'
                          : 'fa-chevron-down'
                      "></i>

                {{ showTextView ? 'Hide' : 'View' }}

              </button>

            </div>


            <!-- Source Content -->
            <div class="source-content" [class.show]="showTextView">
              @for (source of data.source_paragraphs; track $index) {
              <div class="source-item">
                @if (source?.filename) {
                <div class="source-filename">
                  <i class="fas fa-file-pdf"></i>
                  {{ source.filename }}
                </div>
                }

                @if (source?.section_title) {
                <div class="source-section">
                  {{ source.section_title }}
                </div>
                }

                @if (source?.page !== null && source?.page !== undefined) {
                <div class="source-page">
                  Page {{ source.page }}
                </div>
                }

                <div class="source-text">
                  {{ stripHtml(source?.text || source) }}
                </div>
              </div>
              }
            </div>

          </div>



        </div>

        }


        <!-- ===================================================
               MESSAGE ACTIONS
          ==================================================== -->

        <div class="actions">

          <div class="message-actions">

            @for (
            action of actions;
            track action
            ) {

            <button type="button" (click)="handleAction(action, items)" [class.active]="
                    action.toggle && isVoiceActive
                  " [pTooltip]="action.tooltip" tooltipPosition="bottom" tooltipStyleClass="small-tooltip">

              <i class="pi" [ngClass]="
                      action.toggle
                        ? (
                            isVoiceActive
                              ? 'pi-volume-up'
                              : 'pi-volume-off'
                          )
                        : action.icon
                    "></i>

            </button>

            }

          </div>

        </div>

        }

      </div>


      <!-- =======================================================
           MESSAGE DATE
      ======================================================== -->

      @if (!isTyping && data?.created_at) {

      <div class="time">
        {{ data.created_at | date : "MMM dd, yyyy" }}
      </div>

      }

    </div>

  </div>

</div>


<!-- =============================================================
     FEEDBACK POPUP
============================================================== -->

@if (showFeedbackPopup) {

<div class="feedback-overlay">

  <div class="feedback-popup">

    <div class="popup-header">

      <h4>
        Feedback
      </h4>

      <button type="button" class="close-btn" (click)="closeFeedback()">
        <i class="pi pi-times"></i>
      </button>

    </div>


    <div class="feedback-options">

      @for (
      option of feedbackOptions;
      track option
      ) {

      <button type="button" [class.selected]="selectedFeedback === option" (click)="selectedFeedback = option">
        {{ option }}
      </button>

      }

    </div>


    <textarea [(ngModel)]="feedbackComment" placeholder="Additional comments (optional)"></textarea>


    <div class="popup-footer">

      <button type="button" class="cancel-btn" (click)="closeFeedback()">
        Cancel
      </button>

      <button type="button" class="submit-btn" (click)="submitFeedback(data)">
        Submit
      </button>

    </div>

  </div>

</div>

}


<!-- =============================================================
     EDIT ANSWER
============================================================== -->

<p-dialog header="Edit Answer" [(visible)]="isEditAnswerPopupVisible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '700px' }">

  <div class="edit-answer-wrapper">

    <p-editor [(ngModel)]="editAnswerText" [style]="{ height: '300px' }">
      <ng-template pTemplate="header">
        <!-- Text formatting -->
        <span class="ql-formats">
          <button type="button" class="ql-bold" title="Bold"></button>
          <button type="button" class="ql-italic" title="Italic"></button>
          <button type="button" class="ql-underline" title="Underline"></button>
          <button type="button" class="ql-strike" title="Strikethrough"></button>
        </span>

        <!-- Font and size -->
        <span class="ql-formats">
          <select class="ql-font" title="Font">
            <option selected></option>
            <option value="serif"></option>
            <option value="monospace"></option>
          </select>

          <select class="ql-header" title="Heading">
            <option value="1"></option>
            <option value="2"></option>
            <option selected></option>
          </select>
        </span>

        <!-- Text and background colors -->
        <span class="ql-formats">
          <select class="ql-color" title="Text Color"></select>
          <select class="ql-background" title="Background Color"></select>
        </span>

        <!-- Headings and alignment -->
        <span class="ql-formats">

          <select class="ql-align" title="Text Alignment"></select>
        </span>

        <!-- Lists and indentation -->
        <span class="ql-formats">
          <button type="button" class="ql-list" value="ordered" title="Numbered List"></button>
          <button type="button" class="ql-list" value="bullet" title="Bulleted List"></button>
          <button type="button" class="ql-indent" value="-1" title="Decrease Indent"></button>
          <button type="button" class="ql-indent" value="+1" title="Increase Indent"></button>
        </span>

        <!-- Scripts and blocks -->
        <span class="ql-formats">
          <button type="button" class="ql-script" value="sub" title="Subscript"></button>
          <button type="button" class="ql-script" value="super" title="Superscript"></button>
          <button type="button" class="ql-blockquote" title="Blockquote"></button>
          <button type="button" class="ql-code-block" title="Code Block"></button>
        </span>

        <!-- Insert and clear -->
        <span class="ql-formats">
          <button type="button" class="ql-link" title="Insert Link"></button>
          <button type="button" class="ql-image" title="Insert Image"></button>
          <button type="button" class="ql-video" title="Insert Video"></button>
          <button type="button" class="ql-clean" title="Clear Formatting"></button>
        </span>
      </ng-template>
    </p-editor>

  </div>


  <ng-template pTemplate="footer">

    <div class="dialog-footer">

      <button type="button" pButton label="Cancel" class="cancel-btn" (click)="onCancelEditAnswer()"></button>

      <button type="button" pButton label="Save" class="save-btn" (click)="onSaveEditedAnswer()"></button>

    </div>

  </ng-template>

</p-dialog>
